import React, { Component } from 'react'
import Fade from 'react-reveal/Fade'
import Link from '../utils/link'

class ProjectsFilter extends Component {

  state = {
    dropdown: false,
    filterDisciplines: [],
    filterSectors: [],
    initial: true
  }

  shouldComponentUpdate(nextProps, nextState) {
    if ( nextProps.filter !== '' && this.props.filter === '' && this.state.initial ) {
      if (this.props.disciplines.nodes.find((el) => nextProps.filter === el.slug)) this.handleDisciplineClick(nextProps.filter)
      if (this.props.sectors.nodes.find((el) => nextProps.filter === el.slug)) this.handleSectorsClick(nextProps.filter)
      this.setState({ initial: false })
    }
    return true
  }

  handleDisciplineClick = (item) => {
    var array = [...this.state.filterDisciplines]
    var index = array.indexOf(item)
    const url = new URL(window.location)
    if (index !== -1) {
      this.props.setFilter('')
      array.splice(index, 1);
      this.setState({ filterDisciplines: array, dropdown: false }, this.updateList);
    } else {
      this.props.setFilter(item)
      url.searchParams.set('filter', item)
      window.history.pushState({}, '', url)
      this.setState(prevState => ({
        filterDisciplines: [item],
        filterSectors: [], dropdown: false
      }), this.updateList)
    }
  }

  handleSectorsClick = (item) => {
    let array = [...this.state.filterSectors]
    let index = array.indexOf(item)
    const url = new URL(window.location)
    if (index !== -1) {
      this.props.setFilter('')
      array.splice(index, 1);
      this.setState({ filterSectors: array, dropdown: false }, this.updateList);
    } else {
      this.props.setFilter(item)
      url.searchParams.set('filter', item)
      window.history.pushState({}, '', url)
      this.setState(prevState => ({
        filterSectors: [item],
        filterDisciplines: [], dropdown: false
      }), this.updateList)
    }
  }

  updateList = () => {
    const { list, set, projects } = this.props
    const { filterDisciplines, filterSectors } = this.state

    let results = {}

    if (list) {
      results = list?.filter((el, i) => {
        if ( filterDisciplines?.length > 0 ) {
          return el.disciplines.nodes.find((el) => filterDisciplines.includes(el.slug))
        }
        if ( filterSectors?.length > 0 ) {
          return el.sectors.nodes.find((el) => filterSectors.includes(el.slug))
        }
        return true
      })
    }
    if (list.length === results.length) results = projects
    set(results)
  }

  render() {
    let { dropdown, filterDisciplines, filterSectors } = this.state
    let { title, disciplines, sectors } = this.props

    const buttonProps = {
      type: 'button',
      onMouseEnter: () => window?._handleMouseEnter('Link'),
      onMouseLeave: () => window?._handleMouseLeave(),
    }
    
    return (
      <section className='filter'>
        <Fade distance='40px' bottom>
          <div className={`filter__dropdown active`}>
            <div className='filter__inner'>
              <div className='filter__items'>
                <div className='filter__item'>
                  <ul>
                    {disciplines?.nodes?.map((el, i) => (
                      <li key={i}>
                        <Link to={`/discipline/${el.slug}/`}>{el.name}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className='filter__item'>
                  <ul>
                    {sectors?.nodes?.map((el, i) => (
                      <li key={i}>
                        <Link to={`/sector/${el.slug}/`}>{el.name}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </section>
    )
  }
}

ProjectsFilter.defaultProps = {
  title: 'Filter',
  list: [],
  set: () => {},
  disciplines: [],
  sectors: [],
}

export default ProjectsFilter